import React, { useEffect, useState } from "react";
import axios from "axios";
import { useOutletContext } from "react-router-dom";
import toastr from "../../../utils/toast";
import $ from "jquery";

function AllocateUserModal({ onClose, roleId, reference }) {
  const [eligibleUsers, setEligibleUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [loading, setLoading] = useState(false);
  const [isConsultant, setIsConsultant] = useState(true); // toggle state
  const [TotalAllocation, setTotalAllocation] = useState(0);
  const { token, setGlobalLoading } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // Fetch eligible users
  useEffect(() => {
    if (!roleId) return;

    const fetchEligibleUsers = async () => {
      try {
        setGlobalLoading(true);
        const res = await axios.post(
          `${API_BASE_URL}/roles/allocations/add`,
          { role_id: roleId, type: "Internal" }, // request only eligible users
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setEligibleUsers(res.data.eligibleUsers || []);
        setTotalAllocation(res.data.count || 0);
      } catch (err) {
        console.error("Error fetching eligible users:", err);
        setEligibleUsers([]);
      } finally {
        setGlobalLoading(false);
      }
    };

    fetchEligibleUsers();
  }, [roleId]);

  useEffect(() => {
    console.log(TotalAllocation);
    if (TotalAllocation >= 2) {
      alert(
        "There already two resources allocated, if you want to add another then you have to make one resource inactive."
      );
      onClose();
    }
  }, [TotalAllocation]);

  // Allocate user
  const handleAllocate = async () => {
    if (!selectedUser) {
      toastr.error("Please select a user");
      return;
    }

    try {
      setGlobalLoading(true);
      await axios.post(
        `${API_BASE_URL}/roles/allocations/add`,
        {
          role_id: roleId,
          user_id: selectedUser,
          isconsultant: isConsultant ? 1 : 0,
          type: "Internal",
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      isConsultant
        ? toastr.success("User target allocated successfully")
        : toastr.success("User allocated successfully");

      setSelectedUser("");
      onClose();
    } catch (err) {
      console.error("Allocation failed:", err);
      toastr.error(err.response?.data?.message || "Failed to allocate user");
    } finally {
      setGlobalLoading(false);
    }
  };
  useEffect(() => {
  if (!eligibleUsers.length) return;

  const $select = $(".allocate-user-select");

  if ($select.hasClass("select2-hidden-accessible")) {
    $select.select2("destroy");
  }

  $select.select2({
    width: "100%",
    placeholder: "-- Select User --",
    allowClear: true,
    dropdownParent: $select.parent(),
  });

  $select.off("select2:select.allocateUser");
  $select.on("select2:select.allocateUser", function (e) {
    setSelectedUser(e.params.data.id);
  });

  $select.off("select2:clear.allocateUser");
  $select.on("select2:clear.allocateUser", function () {
    setSelectedUser("");
  });

  return () => {
    $select.off(".allocateUser");

    if ($select.hasClass("select2-hidden-accessible")) {
      $select.select2("destroy");
    }
  };
}, [eligibleUsers]);

  return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "500px" }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              Allocate User (Reference: {reference})
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>

          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label">Select User</label>
              <select
                className="form-select allocate-user-select"
                value={selectedUser}
                onChange={(e) => setSelectedUser(e.target.value)}
                disabled={eligibleUsers.length === 0 || loading}
                required
              >
                <option value="">-- Select User --</option>
                {eligibleUsers.map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.firstname} {user.lastname} ({user.designation_name})
                  </option>
                ))}
              </select>
            </div>

            {/* Toggle for target allocation */}
            {/* <div className="form-check form-switch mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="targetSwitch"
                checked={isConsultant}
                onChange={(e) => setIsConsultant(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="targetSwitch">
                Target Allocation
              </label>
            </div> */}

            {eligibleUsers.length === 0 && (
              <p className="text-muted">No eligible users available.</p>
            )}
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-success ms-2"
              onClick={handleAllocate}
              disabled={!selectedUser || loading}
            >
              {loading
                ? isConsultant
                  ? "Target Allocating..."
                  : "Allocating..."
                : isConsultant
                ? "Target Allocate"
                : "Allocate"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AllocateUserModal;
